import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-right', 'ChevronsRight', [["path",{"d":"M7 7l5 5l-5 5"}],["path",{"d":"M13 7l5 5l-5 5"}]]);